import styled from 'styled-components';

import { gray1, gray5, gray6 } from './Const';

export const SidebarTitle = styled.div`
    padding: 0 12px;
`;

export const  CategorySidebarList = styled.ul`
    list-style: none;
    padding-left: 0;
`;

export const Divide = styled.div`
    border-top: 1px solid ${gray5};
`;

export const CategorySidebarListItem = styled.li`
    background-color: transparent;
    padding: 12px;
    border-radius: 3px;
    transition: all 200ms;

    &:hover {
        background-color: ${gray6};
        color: ${gray1};
    }
`;



// WEBPACK FOOTER //
// ./assets/js/styles/CategorySidebar.ts